import { Extension } from '@tiptap/core';
const noop = () => true;
const DisableSpecialCommands = Extension.create({
    addKeyboardShortcuts() {
        return {
            // We handle these manually.
            Enter: noop,
            Backspace: noop,
            // Disable Select all, don't want user deleting everything accidentally
            'Mod-a': () => noop,
        };
    },
});
export default DisableSpecialCommands;
